
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"レイヤー 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"volume up-24px","d":"M0 24.93v14.23a3.56 3.56 0 003.56 3.55h10.66l11.7 11.7A3.57 3.57 0 0032 51.89V12.17a3.56 3.56 0 00-6.08-2.52l-11.7 11.73H3.56A3.57 3.57 0 000 24.93zm48 7.12a16 16 0 00-8.9-14.33v28.62A15.89 15.89 0 0048 32.05zM39.1 5.2v.71a3.33 3.33 0 002.14 3 24.89 24.89 0 010 46.22 3.26 3.26 0 00-2.14 3v.71a3.22 3.22 0 003.21 3.21 3.39 3.39 0 001.09-.2 32 32 0 000-59.74A3.19 3.19 0 0039.3 4a3.31 3.31 0 00-.2 1.12z"}})])
          )
        }
      }
    